// extracted by mini-css-extract-plugin
export var layoutContainer = "_5j-0";
export var layoutContainerNoRounding = "_5j-6";
export var layoutContainerOpen = "_5j-5";
export var layoutContainerResizing = "_5j-1";
export var mainContent = "_5j-2";
export var resizeDivider = "_5j-3";
export var slidePanel = "_5j-4";